module.exports = __webpack_public_path__ + "img/samaria.93b33147.png";